import { MapStyle } from "@components/world-map/world-map-types";
import coloredMapThumb from "@assets/thumbnails/map-thumbs/colored-map-thumb.png";
import satelliteMapThumb from "@assets/thumbnails/map-thumbs/satellite-map-thumb.png";
import { Box } from "@mui/material";

interface Props {
  /** Visual style of the map the thumbnail represents. */
  mapStyle: MapStyle;
}

/** Thumbnail preview of the map style the user will switch to. */
export function MapStyleThumbnail({ mapStyle }: Props): JSX.Element {
  const isColored = mapStyle === "colored";
  return (
    <Box
      component="img"
      src={isColored ? satelliteMapThumb : coloredMapThumb}
      alt={isColored ? "Switch to satellite" : "Switch to colored"}
      sx={{ width: "30px", height: "30px", borderRadius: "4px" }}
    />
  );
}
